module.exports = __webpack_public_path__ + "zilla-slab-latin-700.101c70246a0dc2bd51041f5b52619c4d.woff";